// src/store/Reducers/forWomenCategoriesReducer.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { base_url } from '../../utils/config'

// Async thunk
export const get_for_women_categories = createAsyncThunk(
  'forWomenCategories/get',
  async (_, { getState, rejectWithValue }) => {
    const { token } = getState().auth
    try {
      const { data } = await axios.get(
        `${base_url}/api/category-for-women`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return data.categories
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  }
)

const slice = createSlice({
  name: 'forWomenCategories',
  initialState: {
    items: [],
    loading: false,
    error: ''
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(get_for_women_categories.pending, state => {
        state.loading = true
        state.error = ''
      })
      .addCase(get_for_women_categories.fulfilled, (state, action) => {
        state.loading = false
        state.items = action.payload
      })
      .addCase(get_for_women_categories.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload.error || action.payload
      })
  }
})

export default slice.reducer
